import { DragAndDrop } from "../../../../components/global/DragAndDrop";
import '../../../style.css'
import { motion } from "framer-motion";
import { animationDurationToShowQuestion } from "../../../../config";
import { Fraction } from '../../Fraction'


export const TopPart = ({ state, topNumbers, timeduration, result, level }) => {
    return (
        <div
            className={`text-[32px] text-purple-700 flex overflow-hidden items-center w-full border-[3px] rounded-[16px] border-[#2F9EBA] bg-[#FFF] lg:rounded-[20px] 
            ${state ? "xl:px-[142px] lg:px-[116px] md:px-[85px] toppartIsStateHeight" :
             "toppartIsNotStateHeight xl:px-[156px] lg:px-[140px] md:px-[110px]"}
            text-[#FFF] font-bigfatScript justify-between sm:px-[86px] xs:px-[74px] px-[65px]
  `}
        >
            <div className={`flex justify-around items-center`}>
                <Fraction value={topNumbers[0]} state={state} fromtop={true} mixed={true} />
            </div>

            <motion.div
                //animate={{y: [animate.shift() || 0, 0]}}
                transition={{ duration: animationDurationToShowQuestion, type: "tween", ease: "linear" }}
                className={`${state ? "toppartTextState" : "toppartTextNotState"}`}

            >
                =
            </motion.div>


            <DragAndDrop
                className={"addingresult"}
                isActive={result === "?" ? false : result}
            >
                <div
                    className={`adding
                    h-[42px]
                                    w-[78px]
                                    xs:w-[104px]
                                    xs:h-[54px]
                                    sm:w-[108px] sm:h-[47px]
                                    ${state ? "md:w-[114px] md:h-[49px] lg:w-[150px] lg:h-[69px] xl:w-[200px] xl:h-[82px]" : "md:w-[150px] md:h-[66px] lg:w-[188px] lg:h-[81px] xl:w-[232px] xl:h-[96px]"}
                                    
            rounded-[10px]
            flex
            items-center
            justify-center
            text-white
            ${result === "?" ? "bg-[#E4E4E4]" : "bg-[#85B054]"}
        `}
                >
                    {result === "?" ? "" : <Fraction value={result} state={state} mixed={false}/>}
                </div>
            </DragAndDrop>
        </div>
    )
}